import { Component, OnInit, ViewChild } from '@angular/core';
import { Numerator, NumeratorType } from './numerator.model';
import { NgForm } from '@angular/forms';
import { ObjectToSelect } from '../core/shared/objectToSelect.model';
import { NumeratorRest } from './numerator.rest';
import { HasPermissions, Permissions } from '../core/services/permissions/permissions.model';
import { PermissionsService } from '../core/services/permissions/permissions.service';
import { SpinEditComponent } from '../core/shared/spinedit/spinedit.component';

@Component({
  selector: 'app-numerator',
  templateUrl: './numerator.component.html',
  styleUrls: ['./numerator.component.scss']
})
export class NumeratorComponent implements OnInit, HasPermissions {
  permissions: Permissions;

  public numerator: Numerator;

  private previousNumeratorType: string;
  private previousNumeratorSerie: string;
  private previousNumeratorYear: number;

  private series: ObjectToSelect[];
  private types: ObjectToSelect[];
  private maxYear: number;
  private numeratorType: NumeratorType;
  @ViewChild('numeratorForm') numeratorForm: NgForm;
  @ViewChild('numeratorYear') numeratorYear: SpinEditComponent;
  constructor(private numeratorRest: NumeratorRest, private permissionService: PermissionsService) { }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }
  ngOnInit() {
    this.maxYear = new Date().getFullYear() + 1;
  }

  public setModel(numerator: Numerator, numeratorType: NumeratorType, claimType: string) {
    this.previousNumeratorType = numerator.numeratorType;
    this.previousNumeratorSerie = numerator.serie;
    this.previousNumeratorYear = numerator.year;
    this.numeratorType = numeratorType;
    this.setPermissions(claimType);
    this.getNumeratorSeries(this.numeratorType);
    this.getNumeratorTypes(this.numeratorType);
    this.numerator = numerator;
    this.numerator.isNumeratorReadOnly = !((this.permissions.canEdit || this.permissions.canAdd) && this.numerator.isNew);
    this.numerator.isNumberReadOnly = this.numerator.numeratorType !== 'PRJ' || this.numerator.isNumeratorReadOnly
  }

  private getNumeratorSeries(numeratorType: NumeratorType): void {
    this.numeratorRest.getSeries(numeratorType).subscribe((data: ObjectToSelect[]) => {
      this.series = data;
    });
  }

  private getNumeratorTypes(numeratorType: NumeratorType): void {
    this.numeratorRest.getTypes(numeratorType).subscribe((data: ObjectToSelect[]) => {
      this.types = data;
    });
  }

  onNumeratorTypeChange(event) {
    this.numerator.numeratorType = event;
    if (this.previousNumeratorType === this.numerator.numeratorType)
      return;
    this.onNumeratorChange();
  }

  onNumeratorSerieChange(event) {
    this.numerator.serie = event;
    if (this.previousNumeratorSerie === this.numerator.serie)
      return;
    this.onNumeratorChange();
  }

  onNumeratorNumberChange(event) {
    this.numerator.number = event;
  }

  private onNumeratorChange() {
    if (this.numerator.numeratorType === 'PRJ') {
      this.getNumeratorSeries(NumeratorType.project);
      this.numerator.isNumberReadOnly = false;
      this.numerator.number = null;
    }
    else if (this.numerator.numeratorType === 'ZLC') {
      this.getNumeratorSeries(NumeratorType.order);
      this.numerator.isNumberReadOnly = true;
      this.refreshNumber();
    }
    else if (this.numerator.numeratorType === 'IPRU' || this.numerator.numeratorType === 'PRU') {
      if (this.numeratorType !== NumeratorType.worklog)
        this.getNumeratorSeries(NumeratorType.worklog);
      this.numerator.isNumberReadOnly = true;
      this.refreshNumber();
    }
    else {
      this.getNumeratorSeries(NumeratorType.project);
      this.numerator.isNumberReadOnly = true;
      this.refreshNumber();
    }
  }

  public refreshNumber() {
    if (this.numerator.numeratorType === "PRJ")
      return;
    if (!this.numerator.numeratorType || !this.numerator.serie)
      return;
    this.numeratorRest.getLastNumber(this.numerator).subscribe((data: Number) => {
      this.numerator.number = data.toString();
    });
  }

  private onYearChange(event) {
    this.numerator.year = event;
    if (this.previousNumeratorYear === this.numerator.year)
      return;
    this.onNumeratorChange();
  }

  public isInvalid() {
    if(this.numerator.isNumeratorReadOnly)
      return false;
    return this.numeratorForm.invalid;
  }
}

